var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9167 0.25H5.08333C3.80145 0.25 2.57208 0.759225 1.66565 1.66565C0.759225 2.57208 0.25 3.80145 0.25 5.08333V38.9167C0.25 40.1985 0.759225 41.4279 1.66565 42.3343C2.57208 43.2408 3.80145 43.75 5.08333 43.75H23.5003V26.9281H17.8375V20.3431H23.5003V15.4982C23.5003 9.88187 26.9339 6.81947 31.947 6.81947C33.6367 6.81367 35.3226 6.9026 37.0027 7.07273V12.9462H33.5517C30.8199 12.9462 30.2901 14.2357 30.2901 16.1401V20.3335H36.8151L35.9664 26.9184H30.2515V43.75H38.9186C39.5533 43.75 40.1818 43.625 40.7682 43.3821C41.3546 43.1392 41.8875 42.7832 42.3363 42.3343C42.7851 41.8855 43.1411 41.3527 43.384 40.7663C43.6269 40.1799 43.7519 39.5514 43.7519 38.9167V5.08333C43.7519 3.80145 43.2427 2.57208 42.3363 1.66565C41.4299 0.759225 40.2005 0.25 38.9186 0.25H38.9167Z",
    fill: "#673DE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.826cfe4b6e78e59074b36a194abf12ef.svg";
export { ForwardRef as ReactComponent };